<template>
    <div class="guide-tab">
        <div v-for="(chanelConfig, index) of channelConfigs" :key="chanelConfig.channel">
            <a @click="changeChannel(index)" :class="{ active: activeChannel === index }">
                {{ _lang(`names.${chanelConfig.channel}`) }}
            </a>
        </div>
    </div>
</template>

<script >
// 引导tab
import { _lang } from '../common/lang';
import { activeChannel, changeChannel } from '../common/store';
const __sfc_main = {};
__sfc_main.props = {
  channelConfigs: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  return {
    _lang,
    activeChannel,
    changeChannel
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.guide-tab {
    display: flex;
    height: 0.8rem;
    align-items: center;
    border-bottom: 0.02rem solid #dfdfdf;
    background-color: white;
    width: 100%;

    & > div {
        width: 25%;
        text-align: center;

        & > a {
            color: #606266;
            font-size: 0.3rem;
            font-style: normal;
            font-weight: 400;
            line-height: normal;

            &.active {
                color: #0f1112;
                background: url('../images/tab-line.png') no-repeat left bottom;
                background-size: 100% 0.12rem;
            }
        }
    }
}
</style>
